<template>
  <vs-popup
    button-close-hidden
    class="popup"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <img
      :src="imageUrl || require('@/assets/shipo-sales-plan-no-data.svg')"
      alt="confirm"
    >
    <h3 class="vs-popup--content-title">
      {{ confirmationTitle }}
    </h3>
    <p
      class="vs-popup--content-subtitle"
      v-html="confirmationMessage"
    />
    <div :class="`mt-5 w-full flex ${isReverseButton ? 'flex-row-reverse' : 'flex-row'} justify-center items-center gap-4`">
      <vs-button
        :class="`button font-semibold ${isBusy && 'animate-bounce cursor-not-allowed'}`"
        color="primary"
        type="border"
        :disabled="isBusy"
        @click="$emit('cancel')"
      >
        {{ cancelButtonText }}
      </vs-button>
      <vs-button
        :color="buttonColor"
        :class="`button font-semibold ${isBusy && 'animate-bounce cursor-not-allowed'}`"
        :disabled="isBusy"
        @click="$emit('confirm')"
      >
        {{ confirmationButtonText }}
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'BargeLineUpConfirmationPopUp',
  props: {
    confirmationMessage:{
      type: String,
      default: () => ''
    },
    confirmationTitle: {
      type: String,
      default: () => ''
    },
    confirmationButtonText: {
      type: String,
      default: () => ''
    },
    cancelButtonText: {
      type: String,
      default: () => ''
    },
    isReverseButton: {
      type: Boolean,
      default: () => false
    },
    buttonColor: {
      type: String,
      default: () => 'primary'
    },
    imageUrl: {
      type: String,
      default: () => ''
    },
    isBusy: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-1/4;
    @apply rounded-2xl;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-12;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;
      @apply text-center;
      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }

      &-subtitle {
        @apply text-grey-001;
        @apply mt-2 mb-5;
      }
    }

    &--img {
      width: 152px;
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
